/* eslint-disable no-unused-vars */
import objectUtils from '../../utils/object-utils'
import { buildModelObject, syncItem, syncItemIntoArray } from './helpers'

// TODO: Will be accessed from config !!!
const debug = false
const moduleName = 'ADMIN-DATA'

export default {
  // ---------------------------------------------------- Loaded data management

  // TODO - Change naming to "collection" e.g. setCollection, addCollection !!!

  // dataOpts = {
  //   resource: <resource_name>,
  //   data: <the_model_object>
  // }
  setData (state, dataOpts = {}) {
    const resource = dataOpts.resource
    const data = dataOpts.data
    if (resource) state.dataRegistry[resource] = data
  },

  // dataOpts = {
  //   resource: <resource_name>,
  //   data: <the_model_object>
  // }
  addData (state, dataOpts = {}) {
    const resource = dataOpts.resource
    const data = dataOpts.data
    if (resource) {
      const dataRegistry = state.dataRegistry[resource]
      const collectionItems = (dataRegistry) ? dataRegistry.items : null
      if (collectionItems) collectionItems.push(data)
    }
  },

  // dataOpts = {
  //   resource: <resource_name>,
  //   id: <item_id>
  // }
  removeData (state, dataOpts = {}) {
    const resource = dataOpts.resource
    const itemID = dataOpts.id
    if (resource && itemID) {
      const dataRegistry = state.dataRegistry[resource]
      const collectionItems = (dataRegistry) ? dataRegistry.items : null
      if (collectionItems && collectionItems.length > 0) {
        const updatedItems = collectionItems.filter((item) => {
          return item.id !== itemID
        })
        dataRegistry.items = updatedItems
      }
    }
  },

  clearData (state, resource) {
    if (resource) {
      state.dataRegistry[resource] = null
    }
  },

  // --------------------------------------------------- Item editing management

  // dataOpts = {
  //   resource: <resource_name>
  //   data: <the_model_object> | { ...fields }
  //   from: <the_origin_route>,                 --> optional
  //   persistedDraft: true|false                --> for persisted draft handling
  // }
  setItemToEdit (state, dataOpts = {}) {
    const resource = dataOpts.resource
    const data = dataOpts.data
    const from = dataOpts.from
    const isPersistedDraft = dataOpts.persistedDraft
    if (resource && data) {
      if (!state.editingRegistry[resource]) state.editingRegistry[resource] = {}
      const copy = buildModelObject(resource, data) // build a copy
      if (isPersistedDraft) copy.persistedDraft = true
      state.editingRegistry[resource].itemEditing = copy
      if (from) state.editingRegistry[resource].originRoute = from
      state.editingRegistry[resource].itemEditing_messages = []
      state.editingRegistry[resource].itemEditing_activeMessage = null
    }
  },

  clearItemEditing (state, resource) {
    if (resource && state.editingRegistry[resource]) {
      state.editingRegistry[resource].originRoute = null
      state.editingRegistry[resource].itemEditing = null
      state.editingRegistry[resource].itemEditing_messages = []
      state.editingRegistry[resource].itemEditing_activeMessage = null
    }
  },

  // info = {
  //   resource: <resource_name>
  //   message: <the_message>
  // }
  registerMessageForItemEditing (state, info = {}) {
    const resource = info.resource
    const message = info.message
    if (resource) state.editingRegistry[resource].itemEditing_messages.unshift(message)
  },

  advanceMessageForItemEditing (state, resource) {
    if (resource) {
      // Advance next available message, if ready
      const entry = state.editingRegistry[resource]
      const activeMessage = entry.itemEditing_activeMessage
      if (!activeMessage) entry.itemEditing_activeMessage = entry.itemEditing_messages.pop()
    }
  },

  resolveMessageForItemEditing (state, resource) {
    if (resource) {
      // Clear active message
      const entry = state.editingRegistry[resource]
      entry.itemEditing_activeMessage = null
    }
  },

  // ------------------------------------------------------- Sync registry logic

  // dataOpts = {
  //   resource: <resource_name>
  //   nested: <prop_name>         --> a nested property of the registry (OPTIONAL)
  //   data: <the_model_object>    --> the new item data
  //   replace: true | false       --> replace the existing entry entirely (default: false = merges the data)
  // }
  syncDataItem (state, dataOpts = {}) {
    const resource = dataOpts.resource
    const nested = dataOpts.nested
    const item = dataOpts.data
    const replace = dataOpts.replace
    const syncActionAsText = (replace) ? 'replace' : 'merge' // used for debug logging

    if (resource && item) {
      const itemToSync = objectUtils.cloneDeep(item)
      const itemID = itemToSync.id

      // Access loaded data registry
      const dataRegistry = (nested)
        ? objectUtils.get(state.dataRegistry[resource], nested, {})
        : state.dataRegistry[resource]

      if (debug) {
        if (nested) console.log(`[DEVING] Syncing data into nested path "${nested}" of the "${resource}" data registry (using ${syncActionAsText}):`, dataRegistry)
        else console.log(`[DEVING] Syncing "${resource}" item into the "${resource}" data registry (using ${syncActionAsText}):`, dataRegistry)
      }

      // Perform sync
      if (Array.isArray(dataRegistry)) {
        syncItemIntoArray(itemToSync, dataRegistry)
      } else {
        syncItem(itemToSync, dataRegistry)
      }
    } // end-if (resource && item)
  },

  // dataOpts = {
  //   resource: <resource_name>
  //   nested: <prop_name>         --> a nested property of the registry (OPTIONAL)
  //   data: <the_model_object>    --> the new item data
  //   replace: true | false       --> replace the existing entry entirely (default: false = merges the data)
  // }
  syncItemEditing (state, dataOpts = {}) {
    const resource = dataOpts.resource
    const nested = dataOpts.nested
    const item = dataOpts.data
    const replace = dataOpts.replace
    const syncActionAsText = (replace) ? 'replace' : 'merge' // used for debug logging

    if (resource && item) {
      const itemToSync = objectUtils.cloneDeep(item)
      const itemID = itemToSync.id

      // Access editing registry
      const editingRegistry = (nested)
        ? objectUtils.get(state.editingRegistry[resource].itemEditing, nested, {})
        : state.editingRegistry[resource].itemEditing

      if (debug) {
        if (nested) console.log(`Syncing data into nested path "${nested}" of the "${resource}" editing registry:`, editingRegistry)
        else console.log(`Syncing "${resource}" item into the "${resource}" editing registry:`, editingRegistry)
      }

      // Perform sync
      if (Array.isArray(editingRegistry)) {
        syncItemIntoArray(itemToSync, editingRegistry)
      } else {
        syncItem(itemToSync, editingRegistry)
      }
    } // end-if (resource && item)
  }
} // END - mutations
